import * as types from '../../mutation-types'
import * as api from '../../api'
import moment from 'moment'

const state = {
  log: [],
  log_total_pages: 0,
  log_current_page: 0
}

const getters = {
  allLog: state => state.log,
  logTotalPages: state => state.log_total_pages,
  logCurrentPage: state => state.log_current_page
}

const actions = {
  getLog ({ commit, rootGetters }, params) {
    api.instance.get('log/' + rootGetters.scopedSiteId + '/' + params.page)
      .then(function (response) {
        const log = response.data.log
        commit(types.RECEIVE_LOG, {
          log: log,
          page: response.data.page,
          totalPages: response.data.total_pages
        })
      })
      .catch(function (error) {
        console.log(error)
      })
  },
  clearLog ({ commit }) {
    api.instance.delete('logs')
      .then(function (response) {
        alert(response.data.message)

        if (response.data.success === 'true') {
          commit(types.CLEAR_LOG)
        }
      })
  }
}

const mutations = {
  [types.RECEIVE_LOG] (state, { log, page, totalPages }) {
    log.forEach(function (logEvent) {
      logEvent.message_timestamp = moment(logEvent.message_timestamp)
    })

    state.log = log
    state.log_total_pages = totalPages
    state.log_current_page = page
  },
  [types.CLEAR_LOG] (state) {
    state.log = []
    state.log_total_pages = 0
    state.log_current_page = 0
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
